module.exports = __webpack_public_path__ + "img/USA.e845ea03.jpg";